"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleSheetManager = exports.keyframes = exports.useTheme = exports.css = exports.styled = exports.createGlobalStyle = exports.StyledThemeProvider = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.styled = styled_components_1.default;
Object.defineProperty(exports, "StyleSheetManager", { enumerable: true, get: function () { return styled_components_1.StyleSheetManager; } });
Object.defineProperty(exports, "StyledThemeProvider", { enumerable: true, get: function () { return styled_components_1.ThemeProvider; } });
Object.defineProperty(exports, "createGlobalStyle", { enumerable: true, get: function () { return styled_components_1.createGlobalStyle; } });
Object.defineProperty(exports, "css", { enumerable: true, get: function () { return styled_components_1.css; } });
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return styled_components_1.keyframes; } });
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return styled_components_1.useTheme; } });
